import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is medical billing?",
      answer: "Medical billing is the process of submitting and following up on claims with health insurance companies to receive payment for services rendered by healthcare providers. It involves translating healthcare services into billing codes and ensuring proper reimbursement."
    },
    {
      question: "What is a medical claims billing service?",
      answer: "A medical claims billing service is a professional service that handles the entire billing process for healthcare providers, including claim submission, follow-up, denial management, and payment posting. This allows healthcare providers to focus on patient care while ensuring optimal revenue collection."
    },
    {
      question: "What factors should I consider when selecting a doctor billing company?",
      answer: "Key factors include experience in your specialty, compliance with HIPAA regulations, transparent pricing, proven track record of claim acceptance rates, technology capabilities, customer support availability, and references from other healthcare providers."
    },
    {
      question: "How does an e-Superbill improve claim precision?",
      answer: "An e-Superbill is an electronic version of the traditional superbill that captures all necessary information for billing at the point of care. It improves claim precision by reducing manual data entry errors, ensuring complete documentation, and automatically applying correct coding based on services provided."
    },
    
    {
      question: "What are the fees for medical billing services?",
      answer: "Our fees are transparent and competitive, starting at 2.99% of monthly collections. We offer customized pricing based on your practice size, specialty, and specific needs. There are no setup fees, hidden charges, or long-term contracts required."
    },
    {
      question: "What does the onboarding process involve?",
      answer: "Our onboarding process includes initial consultation, practice assessment, system integration, staff training, data migration, workflow setup, and a transition period with dedicated support. The entire process typically takes 2-4 weeks and is designed to ensure a smooth transition with minimal disruption to your practice."
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-gradient-to-br from-blue-50 to-white py-10">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-blue-500">
            Frequently <span className='text-gray-900'>Asked Questions</span>
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:border-blue-400 transition-colors"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg font-bold pr-4 text-gray-900">
                  {faq.question}
                </span>
                <svg 
                  className={`w-6 h-6 text-gray-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQSection;
